import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Linear Model Info sub-component
 * Displays information message for LIN model (minimal configuration)
 */
export const LinearModelInfo: React.FC = memo(() => {
  const { t } = useTranslation('training');

  return (
    <div className="grid grid-cols-[2fr_3fr] sm:grid-cols-[1fr_2fr] items-center gap-x-3 px-4 py-3 sm:px-6 sm:py-3.5">
      <label className="text-[10px] sm:text-xs uppercase tracking-wide font-medium text-muted-foreground">
        {t('training.modelConfiguration.configuration')}
      </label>
      <p className="text-xs sm:text-sm text-muted-foreground bg-muted rounded-lg px-3 py-2">
        {t('training.modelConfiguration.linearModelDefault')}
      </p>
    </div>
  );
});

LinearModelInfo.displayName = 'LinearModelInfo';

export default LinearModelInfo;
